import { ANALYTICS_SUB_SUITE_IDS } from '../AnalyticsSubSuiteIds';
import { HUBS } from '../../types/relevancyData';
import { DATA_TYPE_FAMILIES } from './DataTypeFamilies';
export const pageRelevancyData = [
// GENERAL
{
  pageNames: ['contacts'],
  patterns: [/\/contacts\/[0-9]*\/objects\/0-1($|\/)/],
  relevancyData: {
    dataTypes: ['0-1'],
    // CONTACT
    subSuites: [ANALYTICS_SUB_SUITE_IDS.CRM_INSIGHTS, ANALYTICS_SUB_SUITE_IDS.ACTIVITIES_AND_LEADS]
  }
}, {
  pageNames: ['companies'],
  patterns: [/\/contacts\/[0-9]*\/objects\/0-2($|\/)/],
  relevancyData: {
    dataTypes: ['0-2'],
    // COMPANY
    subSuites: [ANALYTICS_SUB_SUITE_IDS.CRM_INSIGHTS, ANALYTICS_SUB_SUITE_IDS.ACTIVITIES_AND_LEADS]
  }
},
// MARKETING
{
  pageNames: ['email'],
  patterns: [/\/email\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.MARKETING, HUBS.SALES],
    dataTypes: [DATA_TYPE_FAMILIES.MARKETING_EMAIL, '0-49' // EMAIL (SALES)
    ],
    subSuites: [ANALYTICS_SUB_SUITE_IDS.CHANNEL_PERFORMANCE, ANALYTICS_SUB_SUITE_IDS.ACTIVITIES_AND_LEADS]
  }
}, {
  pageNames: ['ads-free'],
  patterns: [/\/ads\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.MARKETING],
    dataTypes: [DATA_TYPE_FAMILIES.ADS],
    subSuites: [ANALYTICS_SUB_SUITE_IDS.CHANNEL_PERFORMANCE]
  }
}, {
  pageNames: ['ctas', 'ctas-beta'],
  patterns: [/\/calls-to-action\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.MARKETING],
    dataTypes: [DATA_TYPE_FAMILIES.CTAS],
    subSuites: [ANALYTICS_SUB_SUITE_IDS.CHANNEL_PERFORMANCE]
  }
}, {
  pageNames: ['forms'],
  patterns: [/\/forms\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.MARKETING],
    dataTypes: [DATA_TYPE_FAMILIES.FORMS],
    subSuites: [ANALYTICS_SUB_SUITE_IDS.CHANNEL_PERFORMANCE]
  }
}, {
  pageNames: ['pages', 'landing-pages', 'pages-beta', 'landing-pages-beta'],
  patterns: [/\/website\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.CMS, HUBS.MARKETING],
    dataTypes: [DATA_TYPE_FAMILIES.PAGES],
    subSuites: [ANALYTICS_SUB_SUITE_IDS.WEB_TRAFFIC_ANALYSIS]
  }
}, {
  pageNames: ['campaigns'],
  patterns: [/\/marketing\/[0-9]*\/campaigns/],
  relevancyData: {
    hubs: [HUBS.MARKETING],
    dataTypes: [DATA_TYPE_FAMILIES.CAMPAIGNS],
    subSuites: [ANALYTICS_SUB_SUITE_IDS.CHANNEL_PERFORMANCE]
  }
}, {
  pageNames: ['social', 'social-agent'],
  patterns: [/\/social\/[0-9]*\//],
  relevancyData: {
    hubs: [HUBS.MARKETING],
    dataTypes: [DATA_TYPE_FAMILIES.SOCIAL],
    subSuites: [ANALYTICS_SUB_SUITE_IDS.CHANNEL_PERFORMANCE]
  }
}, {
  pageNames: ['sms'],
  patterns: [/\/sms\/[0-9]*\//],
  relevancyData: {
    hubs: [HUBS.MARKETING],
    dataTypes: [DATA_TYPE_FAMILIES.SMS],
    subSuites: [ANALYTICS_SUB_SUITE_IDS.CHANNEL_PERFORMANCE]
  }
}, {
  pageNames: ['buyer-intent'],
  patterns: [/\/buyer-intent\/[0-9]*\//],
  relevancyData: {
    hubs: [HUBS.MARKETING],
    subSuites: [ANALYTICS_SUB_SUITE_IDS.WEB_TRAFFIC_ANALYSIS]
  }
}, {
  pageNames: ['marketingEvents'],
  patterns: [/\/contacts\/[0-9]*\/objects\/0-54($|\/)/],
  relevancyData: {
    hubs: [HUBS.MARKETING],
    dataTypes: [DATA_TYPE_FAMILIES.MARKETING_EVENTS]
  }
}, {
  pageNames: ['marketing-collection-reports-list'],
  patterns: [],
  relevancyData: {
    hubs: [HUBS.MARKETING]
  }
}, {
  pageNames: ['leadScoring'],
  patterns: [/\/lead-scoring\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.MARKETING, HUBS.SALES]
  }
}, {
  pageNames: ['blog', 'blog-beta'],
  patterns: [/\/website\/[0-9]*\/blog/],
  relevancyData: {
    hubs: [HUBS.CMS, HUBS.MARKETING],
    dataTypes: [DATA_TYPE_FAMILIES.BLOG]
  }
}, {
  pageNames: ['seo'],
  patterns: [/\/content-strategy\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.CMS, HUBS.MARKETING],
    dataTypes: [DATA_TYPE_FAMILIES.SEO],
    subSuites: [ANALYTICS_SUB_SUITE_IDS.WEB_TRAFFIC_ANALYSIS]
  }
},
// SERVICE
{
  pageNames: ['help-desk', 'tickets', 'service-reports-list'],
  patterns: [/\/help-desk\/[0-9]*/, /\/contacts\/[0-9]*\/objects\/0-5($|\/)/],
  relevancyData: {
    hubs: [HUBS.SERVICE],
    dataTypes: ['0-5',
    // TICKET
    '0-11',
    // CONVERSATION
    DATA_TYPE_FAMILIES.HD_MESSAGES],
    subSuites: [ANALYTICS_SUB_SUITE_IDS.TEAM_PERFORMANCE, ANALYTICS_SUB_SUITE_IDS.TICKET_REPLIES]
  }
}, {
  pageNames: ['customerSuccess', 'customerSuccess-beta', 'surveys'],
  patterns: [/\/customer-success\/[0-9]*/, /\/feedback\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.SERVICE],
    dataTypes: [DATA_TYPE_FAMILIES.FEEDBACK],
    subSuites: [ANALYTICS_SUB_SUITE_IDS.CUSTOMER_SATISFACTION]
  }
}, {
  pageNames: ['inbox', 'chatflows'],
  patterns: [/\/live-messages\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.SALES, HUBS.SERVICE],
    dataTypes: ['0-11', '0-46'] // CONVERSATION, CHATFLOW
  }
}, {
  pageNames: ['knowledge-base'],
  patterns: [/\/knowledge\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.SERVICE],
    dataTypes: [DATA_TYPE_FAMILIES.KNOWLEDGE_BASE]
  }
},
// SALES
{
  pageNames: ['sales', 'sales-reports-list'],
  patterns: [/\/prospecting\/[0-9]*\/$/],
  relevancyData: {
    hubs: [HUBS.SALES],
    dataTypes: ['0-136',
    // LEAD
    '0-3',
    // DEAL
    '0-4',
    // ENGAGEMENT
    '0-47',
    // MEETING
    '0-48',
    // CALL
    DATA_TYPE_FAMILIES.SEQUENCES, '0-27' // TASK
    ],
    subSuites: [ANALYTICS_SUB_SUITE_IDS.ACTIVITIES_AND_LEADS]
  }
}, {
  pageNames: ['deals'],
  patterns: [/\/contacts\/[0-9]*\/objects\/0-3($|\/)/],
  relevancyData: {
    hubs: [HUBS.SALES],
    dataTypes: ['0-3'],
    // DEAL
    subSuites: [ANALYTICS_SUB_SUITE_IDS.DEALS]
  }
}, {
  pageNames: ['tasks'],
  patterns: [/\/tasks\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.SALES],
    dataTypes: ['0-27', '0-4'],
    // TASK, ENGAGEMENT
    subSuites: [ANALYTICS_SUB_SUITE_IDS.ACTIVITIES_AND_LEADS]
  }
}, {
  pageNames: ['calls'],
  patterns: [/\/contacts\/[0-9]*\/objects\/0-48($|\/)/],
  relevancyData: {
    hubs: [HUBS.SALES],
    dataTypes: ['0-48', '0-4'],
    // CALL, ENGAGEMENT
    subSuites: [ANALYTICS_SUB_SUITE_IDS.ACTIVITIES_AND_LEADS]
  }
}, {
  pageNames: ['sequences'],
  patterns: [/\/sequences\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.SALES],
    dataTypes: [DATA_TYPE_FAMILIES.SEQUENCES, '0-4'],
    // ENGAGEMENT
    subSuites: [ANALYTICS_SUB_SUITE_IDS.ACTIVITIES_AND_LEADS]
  }
}, {
  pageNames: ['forecasting'],
  patterns: [/\/forecasting\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.SALES],
    dataTypes: ['0-60'],
    // FORECAST
    subSuites: [ANALYTICS_SUB_SUITE_IDS.DEALS]
  }
}, {
  pageNames: ['goals-app'],
  patterns: [/\/goals\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.MARKETING, HUBS.SALES, HUBS.SERVICE],
    dataTypes: ['0-74'],
    // GOAL_TARGET
    subSuites: [ANALYTICS_SUB_SUITE_IDS.DEALS]
  }
}, {
  pageNames: ['sales-products'],
  patterns: [/\/contacts\/[0-9]*\/objects\/0-7($|\/)/],
  relevancyData: {
    hubs: [HUBS.SALES, HUBS.COMMERCE],
    dataTypes: ['0-8']
  }
}, {
  pageNames: ['templates'],
  patterns: [/\/templates\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.SALES],
    dataTypes: [DATA_TYPE_FAMILIES.TEMPLATES]
  }
}, {
  pageNames: ['documents'],
  patterns: [/\/documents\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.SALES],
    dataTypes: [DATA_TYPE_FAMILIES.DOCUMENTS]
  }
}, {
  pageNames: ['playbooks', 'coaching-playlists'],
  patterns: [/\/playbooks\/[0-9]*/, /\/playlists\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.SALES]
  }
},
// COMMERCE
{
  pageNames: ['commerce'],
  patterns: [/\/commerce\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.COMMERCE, HUBS.SALES],
    dataTypes: ['0-101',
    // COMMERCE_PAYMENT
    '0-69',
    // SUBSCRIPTION
    '0-123',
    // ORDER
    '0-14',
    // QUOTE
    '0-53',
    // INVOICE
    '0-118',
    // PAYMENT_LINK
    '0-3' // DEAL
    ]
  }
}, {
  pageNames: ['invoices'],
  patterns: [/\/contacts\/[0-9]*\/objects\/0-53/],
  relevancyData: {
    hubs: [HUBS.COMMERCE, HUBS.SALES],
    dataTypes: ['0-53'] // INVOICE
  }
}, {
  pageNames: ['payment-links'],
  patterns: [/\/payment-links\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.COMMERCE, HUBS.SALES],
    dataTypes: ['0-118'] // PAYMENT_LINK
  }
}, {
  pageNames: ['subscriptions-uindex'],
  patterns: [/\/contacts\/[0-9]*\/objects\/0-69/],
  relevancyData: {
    hubs: [HUBS.COMMERCE, HUBS.SALES],
    dataTypes: ['0-69'] // SUBSCRIPTION
  }
}, {
  pageNames: ['quotes'],
  patterns: [/\/quotes\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.COMMERCE, HUBS.SALES],
    dataTypes: ['0-14'] // QUOTE
  }
}, {
  pageNames: ['payments-v5'],
  patterns: [/\/contacts\/[0-9]*\/objects\/0-101/],
  relevancyData: {
    hubs: [HUBS.COMMERCE, HUBS.SALES],
    dataTypes: ['0-101'] // COMMERCE_PAYMENT
  }
},
// OPS
{
  pageNames: ['data-quality'],
  patterns: [/\/data-quality\/[0-9]*/],
  relevancyData: {
    hubs: [HUBS.OPS]
  }
}];